import { Box, Dialog, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const DialogBox = styled(Box)(({ theme }) => ({
  width: '350px',
  height: '300px',
  padding: '14px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#FEFEFE',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.3)',
  [theme.breakpoints.down('md')]: {
    width: '330px',
  },
  [theme.breakpoints.down('md')]: {
    width: '280px',
  },
}));

const InnerYellowFrame = styled(Box)({
  width: '320px',
  height: '270px',
  padding: '15px',
  border: '1px solid #AA9178',
});

const ProfileImage = styled(Box)(({ variant }) => ({
  display: 'flex',
  justifyContent: 'center',
  dropShadow: '0px 2px 2px rgba(0, 0, 0, 0.4)',
  // marginTop: '16px',
  '& img': {
    width: '100px',
    height: '100px',
    borderRadius: `${variant === 'cafe' ? 0 : 75}px`,
    objectFit: 'cover',
  },
}));

const ContentText = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '19px',
  marginTop: '16px',
  color: '#000000',
});

const NameTypography = styled(Typography)({
  fontFamily: 'Fjalla One',
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '19px',
  color: '#000000',
  margin: '0 4px',
});

const ButtonGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '18px',
  alignItems: 'center',
  gap: '10px',
});

const ActionButton = styled(Button)(({ type }) => ({
  width: `${type === 'unlike' ? 80 : 100}px`,
  height: '40px',
  fontFamily: 'Fjalla One',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  backgroundColor: 'black',
  color: 'white',
  '&:hover': {
    color: 'black',
  },
  border: 'none',
  borderRadius: '0',
  textTransform: 'uppercase',
}));

const CancelButton = styled(Button)(({ type }) => ({
  width: `${type === 'unlike' ? 80 : 100}px`,
  height: '40px',
  fontFamily: 'Fjalla One',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  border: 'none',
  backgroundColor: 'white',
  color: '#000000',
  textTransform: 'uppercase',
}));

export default function ActionDialog({
  open,
  onClose,
  img,
  name,
  variant,
  action,
  actionHandler,
  cancelHandler,
}) {
  return (
    <Dialog PaperProps={{ style: { borderRadius: 0 } }} onClose={onClose} open={open}>
      <DialogBox>
        <InnerYellowFrame>
          <ProfileImage variant={variant}>
            <img src={img} alt={name} />
          </ProfileImage>
          <ContentText>
            {action.toLowerCase()} @ <NameTypography>{name}</NameTypography>?
          </ContentText>
          <ButtonGroup>
            <ActionButton onClick={actionHandler} type={action}>
              {action.toUpperCase()}
            </ActionButton>
            <CancelButton onClick={cancelHandler} type={action}>
              CANCEL
            </CancelButton>
          </ButtonGroup>
        </InnerYellowFrame>
      </DialogBox>
    </Dialog>
  );
}
